import ButtonComponent from '@pretto/bricks/components/buttons/Button'
import * as helpers from '@pretto/bricks/components/helpers'
import { breakpoints, g } from '@pretto/bricks/components/layout'
import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'
import * as typo from '@pretto/bricks/core/typography'

import { Status as StatusComponent } from '@pretto/zen/atoms/infos/Status/Status'

import styled, { css } from 'styled-components'

export const Card = styled.div`
  ${helpers.boxShadow('card')}
  background-color: ${({ theme }) => theme.colors.primary1};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${g(1)};
  padding: ${g(2)} ${g(3)};
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${g(4)};
  }
`
export const Overlay = styled.div`
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.neutral1}B2;
  border-radius: inherit;
  display: flex;
  align-items: center;
  z-index: 1;
  flex-direction: column;
  transition: opacity 250ms ease-in-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
    `}
`
export const OverlayContent = styled.p`
  ${typo.textLarge24};
  width: ${g(38)};
  text-align: center;
`
export const SvgArrowDesktop = styled(ResponsiveSSR).attrs({ forwardedAs: 'svg', min: 'laptop' })`
  align-self: start;
  margin-top: ${g(10)};
  margin-bottom: ${g(2)};
  margin-left: ${g(3)};
  fill: ${({ theme }) => theme.colors.white};
`
export const SvgArrowTablet = styled(ResponsiveSSR).attrs({ forwardedAs: 'svg', min: 'tablet', max: 'laptop' })`
  margin-top: ${g(6)};
  margin-bottom: ${g(4.5)};
  fill: ${({ theme }) => theme.colors.white};
`
export const Result = styled.div`
  grid-gap: ${g(3)};
  grid-template-columns: repeat(2, 1fr);
`
export const Highlight = styled.div`
  ${typo.numbers48};
  margin-top: ${g(2)};
  white-space: nowrap;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      color: ${({ theme }) => theme.colors.primary2};
    `}
`
export const HighlightSuffix = styled.span`
  ${typo.numbers40};
`
export const Value = styled.div`
  ${typo.isNumber};
  ${typo.numbersBold16};
  display: flex;
  align-items: center;

  ${({ $isEmpty }) =>
    $isEmpty &&
    css`
      color: ${({ theme }) => theme.colors.primary2};
    `}
`
export const Suffix = styled.span`
  ${typo.bodyBook16};
  margin-left: ${g(1)};
`
export const Divider = styled(ResponsiveSSR).attrs({ min: 'tablet' })`
  display: block;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.white};
  margin: ${g(3)} 0;
`
export const Button = styled(ButtonComponent).attrs({ isSecondary: true })`
  z-index: 1;
  margin: ${g(3)} 0;
`

export const Container = styled.div`
  position: relative;
`
export const Row = styled.li`
  display: flex;
  justify-content: space-between;

  & + & {
    margin-top: ${g(1)};
  }
`

export const Status = styled(StatusComponent)`
  position: absolute;
  top: ${g(4)};
  right: ${g(4)};

  ${({ $isError }) =>
    $isError &&
    css`
      background-color: ${({ theme }) => theme.colors.error1};
      color: ${({ theme }) => theme.colors.white};
    `}
`
